import TextField from "@mui/material/TextField";
import React from "react";

interface ITopControlProps {
    onChange: (top: number) => void;
    value: number;
}

export default function TopControl({ onChange, value }: ITopControlProps) {
    return (
        <TextField
            slotProps={{ htmlInput: { max: 500, min: 1 } }}
            label="$top"
            onChange={(e) =>
                onChange(
                    Math.max(1, Math.min(500, Number(e.target.value) || 0)),
                )
            }
            sx={{ width: 120 }}
            type="number"
            value={value}
            size="small"
        />
    );
}
